import { defaultSgaCompleto } from "./state";

/**
 * Mutación que lista la información de SGA completo de un producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} sgacompleto contiene la información de sga completo del producto químico.
 */
export function setSgaCompleto(state, sgacompleto) {
    Object.assign(state.selectedSgaCompleto, sgacompleto);
}

/**
 * Mutación para cambiar el idioma de la clasificación.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} idioma contiene la información de los idiomas.
 */
export function cambiaIdioma(state, idioma) {
    state.idioma = idioma;
}

/**
 * Mutación para cambiar la versión de SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} version contiene la información de versión de SGA.
 */
export function cambiaVersion(state, version) {
    state.version = version;
}
/**
 * Mutación para obtener las listas paramétricas de clasificación SGA
 *
 * @export
 * @param {*} state
 * @param {*} sgaListas
 */
export function setClasificacionSGAListas(state, sgaListas) {
    state.clasificacionSGAListas.sinSGA = sgaListas[0].lista;
}

/**
 * Mutación para determinar acceso a la visualización de las pestañas de SGA Completo y Frases SGA
 *
 * @export
 * @param {*} state
 * @param {*} tipo contiene un string con el tipo de pestaña a evaluar
 * @return {boolean}
 */
export function validarVisibilidadSga(state, data) {
    if (state.selectedSgaCompleto.almacenamiento.length ||
        state.selectedSgaCompleto.clasePeligro.length ||
        state.selectedSgaCompleto.eliminacion.length ||
        state.selectedSgaCompleto.indicaciones.length ||
        state.selectedSgaCompleto.intervencion.length ||
        state.selectedSgaCompleto.palabraSga.length ||
        state.selectedSgaCompleto.prevencion.length) {
        state.visibilidadSgaCompleto = true;

        state.visibilidadFrasesSga = !!(data.admin || data.esAdminTec || data.esEmpresaContratista);
    } else {
        state.visibilidadSgaCompleto = false;
        state.visibilidadFrasesSga = false;
    }
}
